// Auto-generated skeleton for CisType

export const CisType: Api.CisType = {
  id: 0,
  hp_id: null,
  description: '',
  created: null,
  updated: null,
};

